<template>
  <div class="fontpicker" :tabindex="tabindex" @blur="open = false">
    <h2>Wähle eine Schrift</h2>
    <div class="options" >
      <div
        v-for="(font, i) of fonts"
        :key="i"
        @click="
          selected = font;
          open = false;
          $emit('input', font);
        "
        :style="fontStyles(font.value.family, font.value.weight)"
      >
        <div class="option-line">
          <div>{{ font.text }}</div>
          <div v-if="font.text == selected.text"><img src="~@/assets/imgs/check.svg" /></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fonts: {
      type: Array,
      required: true,
    },
    default: {
      type: String,
      required: false,
      default: null,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      selected: this.fonts[0],
      open: true,
    };
  },
  methods: {
    fontStyles(family, weight) {
      return `font-family: ${family}; font-weight: ${weight}`;
    }
  },
  mounted() {
    this.$emit("input", this.selected);
  },
};
</script>
<style lang="scss" scoped>
div {
  border-bottom: 0px;
}
.option-line {
  padding-bottom: .5em;
  padding-top: .5em;
  border-bottom: 2px solid #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

</style>
